import React, { useState } from 'react';
import { actions, elements } from '@ecosystem/newron-design-system';
import { ActionType, UpdateProductGroupModal } from './updateProductGroupModal';
import { useMobile } from '../../context/mobile/mobile.provider';
const { Menu } = actions;
const { Icon } = elements;

interface ProductGroupMenuProps {
  group: string;
  allGroups: string[];
  onDelete: (name) => void;
  onEdit: (name) => void;
  disabled?: boolean;
}

export const ProductGroupMenu: React.FC<ProductGroupMenuProps> = ({ group, onDelete, onEdit, allGroups, disabled }) => {
  const [showActionGroupModal, setShowActionGroupModal] = useState(false);
  const [actionType, setActionType] = useState(ActionType.Delete);
  const { isMobile } = useMobile();
  const handleClick = e => {
    e.stopPropagation();
  };

  const toggleUpdateGroupModal = () => {
    setShowActionGroupModal(prev => !prev);
  };

  const handleActionModal = (type: ActionType) => {
    setActionType(type);
    toggleUpdateGroupModal();
  };

  const handleAction = (groupName: string) => {
    if (actionType === ActionType.Delete) {
      onDelete(groupName);
    } else {
      onEdit(groupName);
    }
    toggleUpdateGroupModal();
  };

  const handleClose = e => {
    e.stopPropagation();
    toggleUpdateGroupModal();
  };

  return (
    <>
      <UpdateProductGroupModal
        type={actionType}
        group={group}
        allGroups={allGroups}
        isOpen={showActionGroupModal}
        onAction={handleAction}
        onClose={handleClose}
      />
      <Menu testId="product-group-menu" isDisabled={disabled}>
        {!isMobile && (
          <div onClick={e => handleClick(e)} aria-hidden="true">
            <Menu.MoreButton testId="more-button" />
          </div>
        )}

        <Menu.List>
          <Menu.Item
            onSelect={() => {
              handleActionModal(ActionType.Rename);
            }}
            testId="rename-button"
          >
            <Icon>
              <Icon.icons.AddGroup />
            </Icon>
            Rename
          </Menu.Item>
          <Menu.Item
            onSelect={() => {
              handleActionModal(ActionType.Delete);
            }}
            testId="delete-button"
          >
            <Icon>
              <Icon.icons.Delete />
            </Icon>
            Delete...
          </Menu.Item>
        </Menu.List>
      </Menu>
    </>
  );
};
